import React, { useState } from "react";

function Tabs({ tablist, setActive, active, onFilter = () => {}, dashboard }: any) {
  return (
    <div className="tab-choose mt-2">
      <ul>
        {tablist?.map((a, i) => (
          <li
            key={i}
            className={`f-14 me-3 cursor ${
              a.id === active
                ? dashboard
                  ? "f-18 fw-500 tab-active"
                  : "tab-active f-18 fw-600"
                : ""
            }`}
            onClick={() => {
              setActive(a.id);
              onFilter(a.name);
            }}
          >
            {a.name}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Tabs;
